const EmployeeBenefits = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="sm:text-[40px] text-[30px] font-bold">
          Employee Benefits
        </h1>
      </div>
      <div className="lg:flex grid text-[#373737] my-[3rem] mx-[2rem]">
        <div className="max-w-[70rem] mx-auto flex flex-col md:flex-row justify-between ">
          <div className="flex-1 flex flex-col lg:px-[3.8rem]">
            <p className="react-reveal ">
              In order to make sure that TCS continues to attract and retain
              high quality talent, we offer competitive salary packages and
              wide-ranging employee benefits such as, annual leaves, medical
              assistance, paid sickness and maternity leaves, countrywide free
              lab tests, life, health and accidental insurance and provident
              fund. Other fringe benefits include support for female employees
              ’travel to and from work, fuel, mobile and special allowances on
              Ramadan and Eid occasions, and educational support for employees’
              children.
            </p>
          </div>

          <div className="flex gap-1 flex-1  lg:pr-[2rem] mt-[2rem] lg:mt-[0rem]">
            <div className="flex flex-col gap-1">
              <img
                src="/Home/employee1.jpg"
                alt=""
                className="react-reveal   "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EmployeeBenefits;
